import React from "react";
import {
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
} from "reactstrap";
import NProgress from "nprogress";

import i18n from "../../../i18n";

export default function LanguageDropdown(): JSX.Element {
    const [menu, setMenu] = React.useState<boolean>(false);
    const [language, setLanguage] = React.useState<string>(
        i18n.language.includes("fr") || i18n.language.includes("FR")
            ? "Français"
            : "English"
    );

    function changeLanguage(currentLanguage: string): void {
        i18n.changeLanguage(currentLanguage === "en" ? "en" : "fr");

        if (currentLanguage === "en") {
            setLanguage("English");
        } else if (currentLanguage === "fr") {
            setLanguage("Français");
        }
    }
    return (
        <Dropdown
            isOpen={menu}
            toggle={() => setMenu(!menu)}
            className="d-inline-block"
        >
            <DropdownToggle
                className="btn header-item waves-effect"
                tag="button"
            >
                {" "}
                <span className="align-middle">
                    {language === "Français" ? (
                        <img
                            alt="img"
                            style={{ width: "35px" }}
                            src="https://flagpedia.net/data/flags/h80/fr.webp"
                        />
                    ) : (
                        <img
                            alt="img"
                            style={{ width: "40px" }}
                            src="https://flagpedia.net/data/flags/h80/us.webp"
                        />
                    )}
                </span>
            </DropdownToggle>
            <DropdownMenu className="language-switch">
                <DropdownItem
                    tag="a"
                    onClick={async () => {
                        NProgress.start();
                        changeLanguage(language === "English" ? "fr" : "en");
                        NProgress.done();
                    }}
                    className={`notify-item ${
                        language === "English" ? "active" : "none"
                    } ${language === "English" ? "d-none" : ""}`}
                >
                    <span className="align-middle">
                        <img
                            alt="img"
                            style={{ width: "40px" }}
                            src="https://flagpedia.net/data/flags/h80/us.webp"
                        />
                    </span>
                </DropdownItem>
                <DropdownItem
                    tag="a"
                    onClick={() => changeLanguage("fr")}
                    className={`notify-item ${
                        language === "Français" ? "active" : "none"
                    } ${language === "Français" ? "d-none" : ""}`}
                >
                    <span className="align-middle">
                        <img
                            alt="img"
                            style={{ width: "35px" }}
                            src="https://flagpedia.net/data/flags/h80/fr.webp"
                        />
                    </span>
                </DropdownItem>
            </DropdownMenu>
        </Dropdown>
    );
}
